var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSwitchAccountStreamlinePlump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48",
    id: "User-Switch-Account--Streamline-Plump",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "User Switch Account Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-switch-account"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fill: "#0f2651",
    d: "M11 25.5a6.5 6.5 0 0 0 -4.105 11.54c-2.696 1.302 -4.708 3.828 -5.349 6.87 -0.308 1.464 0.94 2.59 2.284 2.59h14.458c1.344 0 2.591 -1.126 2.283 -2.59 -0.647 -3.07 -2.689 -5.614 -5.422 -6.906A6.5 6.5 0 0 0 11 25.5Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    fill: "#0f2651",
    d: "M37 1.5a6.5 6.5 0 0 1 4.106 11.54c2.696 1.302 4.708 3.828 5.349 6.87 0.308 1.464 -0.94 2.59 -2.284 2.59H29.713c-1.344 0 -2.592 -1.126 -2.283 -2.59 0.646 -3.07 2.689 -5.614 5.422 -6.906A6.5 6.5 0 0 1 37 1.5Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    fill: "#a0c3ed",
    d: "M5.686 11.58c0.048 -1.005 0.1 -1.898 0.155 -2.683 0.26 -3.784 3.168 -6.75 6.975 -7.034 2.553 -0.19 6.25 -0.363 11.238 -0.363 0.325 0 0.644 0 0.957 0.002a2.5 2.5 0 0 1 -0.022 5l-0.935 -0.002c-4.873 0 -8.445 0.17 -10.867 0.35 -1.303 0.097 -2.267 1.062 -2.358 2.39 -0.048 0.695 -0.095 1.483 -0.139 2.37 0.787 0.065 1.55 0.16 2.265 0.283 1.746 0.303 2.55 2.281 1.569 3.72 -1.574 2.306 -3.689 4.607 -4.753 5.72a2.452 2.452 0 0 1 -3.54 0.011c-1.103 -1.138 -3.348 -3.545 -4.824 -5.779 -0.962 -1.454 -0.109 -3.364 1.58 -3.661a26.42 26.42 0 0 1 2.699 -0.324Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_4",
    fill: "#a0c3ed",
    d: "M42.314 36.42a26.452 26.452 0 0 0 2.7 -0.324c1.688 -0.297 2.541 -2.207 1.58 -3.661 -1.477 -2.234 -3.722 -4.641 -4.825 -5.78a2.452 2.452 0 0 0 -3.54 0.012c-1.064 1.113 -3.18 3.414 -4.753 5.72 -0.982 1.439 -0.177 3.417 1.569 3.72 0.716 0.124 1.478 0.218 2.265 0.284a123.21 123.21 0 0 1 -0.139 2.369c-0.091 1.328 -1.055 2.293 -2.36 2.39 -1.89 0.141 -4.483 0.275 -7.85 0.327a2.5 2.5 0 1 0 0.078 5c3.459 -0.054 6.15 -0.192 8.144 -0.34 3.807 -0.284 6.716 -3.25 6.976 -7.034 0.054 -0.785 0.107 -1.678 0.155 -2.683Z",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSwitchAccountStreamlinePlump);
export default __webpack_public_path__ + "static/media/User-Switch-Account--Streamline-Plump.b250a4053710022a9cbb9f363c540628.svg";
export { ForwardRef as ReactComponent };